import socketIO, { Socket } from 'socket.io-client';

import { urlsConfig } from 'src/configs';

let socket: Socket | undefined;

export const createConnection = () => {
  if (socket?.connected) {
    return;
  }

  socket = socketIO(urlsConfig.webServerBaseURL.split('/etecubeApi')[0], {
    transports: ['websocket'],
    upgrade: true,
    path: '/socketApi',
  });
};

export const listenSocket = (id: string, callback: (data: any) => void) => {
  socket?.off(id);
  socket?.on(id, callback);
};

export const closeSocket = () => {
  socket?.close();
};

export const isSocketConnected = (): boolean => {
  return socket?.connected ?? false;
};
